import { Box, Typography } from '@mui/material'

export default function EarnInYourLocation() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: 'center',
        justifyContent: 'center',
        gap: { xs: 4, md: 8 },
        px: 2,
        py: 6,
        backgroundColor: '#0E0E0E'
      }}
    >
      {/* LEFT - Image */}
      <Box
        sx={{
          flex: 1,
          maxWidth: { xs: '100%', md: '700px' }, // you can adjust
          width: '100%'
        }}
      >
        <img
          src={`${process.env.IMAGE_BASE_URL}/images/userwebsite/supplier/earnLocation.png`}
          alt='Phone'
          style={{ width: '100%', height: 'auto', borderRadius: '12px' }}
        />
      </Box>

      {/* RIGHT - Text and Steps */}
      <Box
        sx={{
          flex: 1,
          maxWidth: { xs: '100%', md: '500px' }, // matching left
          width: '100%'
        }}
      >
        <Typography
          variant='h4'
          fontWeight='bold'
          color='white'
          mb={2}
          sx={{
            fontSize: { xs: '28px', md: '36px' },
            textAlign: { xs: 'center', md: 'left' }
          }}
        >
          You Could Earn
          <Box component='span' color='#5FCFC7' display='inline'>
            {' '}
            5,614 AED{' '}
          </Box>
          Per Month
          <br />
          In Your Location
        </Typography>

        <Box
          sx={{
            backgroundColor: '#132625',
            borderRadius: '16px',
            p: 4,
            mt: 4
          }}
        >
          <Step number='1' text='Register your business' type='solid' />
          <Step
            number='2'
            text='Submit your activity for review'
            type='dashed'
          />
          <Step number='3' text='Done, Start earning' type='last' />
        </Box>
      </Box>
    </Box>
  )
}

function Step({ number, text, type }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        mb: type === 'last' ? 0 : 4,
        position: 'relative'
      }}
    >
      {/* Circle Number */}
      <Box
        sx={{
          width: 64,
          height: 64,
          borderRadius: '50%',
          backgroundColor: '#5FCFC7',
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 'bold',
          fontSize: '20px',
          flexShrink: 0,
          zIndex: 1
        }}
      >
        {number}
      </Box>

      {/* Vertical Line */}
      {type !== 'last' && (
        <Box
          sx={{
            position: 'absolute',
            top: 64,
            left: 32,
            width: '2px',
            height: '30px',
            background:
              type === 'solid'
                ? '#5FCFC7' // solid line
                : 'repeating-linear-gradient(to bottom, #5FCFC7 0px, #5FCFC7 6px, transparent 6px, transparent 12px)' // dashed
          }}
        />
      )}

      {/* Step Text */}
      <Typography
        sx={{
          ml: 3,
          color: 'white',
          fontSize: '18px',
          mt: '8px'
        }}
      >
        {text}
      </Typography>
    </Box>
  )
}
